import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { usePrevious } from '../../lib/utils/hooks';
import { State as WebsocketState } from '../../lib/reducers/websocket';

const messages = defineMessages({
  ok: { id: 'ok' },
  content: { id: 'meetingLeftDialogContent' },
  kickedContent: { id: 'meetingLeftDialogContentWhenKicked' },
  endedContent: { id: 'meetingLeftDialogContentWhenEnded' },
  iceFailedContent: { id: 'meetingLeftDialogContentWhenIceFailed' },
  title: { id: 'meetingLeftDialogTitle' },
});


type State = {
  websocket: WebsocketState;
}

type MappedProps = {
  meetingLeftReason: string | null;
}


type ExtendedProps = MappedProps & RouteComponentProps;


function MeetingLeftDialog(props: ExtendedProps) {
  const [openMeetingLeftDialog, setOpenMeetingLeftDialog] = React.useState(false);
  const { meetingLeftReason } = props;
  const prevMeetingLeftReason = usePrevious(meetingLeftReason, '');
  const { formatMessage } = useIntl();

  const getContent = () => {
    if (meetingLeftReason === 'kicked') {
      return formatMessage(messages.kickedContent);
    }
    else if (meetingLeftReason === 'ended') {
      return formatMessage(messages.endedContent);
    }
    else if (meetingLeftReason === 'ice_failed') {
      return formatMessage(messages.iceFailedContent);
    }
    else {
      return formatMessage(messages.content);
    }
  };

  const handleConfirm = (): void => {
    setOpenMeetingLeftDialog(false);
    props.history.push('/', { doNotConfirm: true });
  };

  React.useEffect(() => {
    if (meetingLeftReason && !prevMeetingLeftReason) {
      setOpenMeetingLeftDialog(true);
    }
    else if (openMeetingLeftDialog && !meetingLeftReason) {
      setOpenMeetingLeftDialog(false);
    }

  }, [meetingLeftReason, prevMeetingLeftReason, openMeetingLeftDialog]);


  return (
    <Dialog
      open={openMeetingLeftDialog}
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="sm">
      <DialogTitle>
        {formatMessage(messages.title)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {getContent()}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleConfirm} color="primary">
          {formatMessage(messages.ok)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapStateToProps = (state: State): MappedProps => {
  const meetingLeftReason = state.websocket.leaveReason;
  return ({ meetingLeftReason });
};


export default (withRouter(connect(mapStateToProps)(MeetingLeftDialog)));
